import { observer } from "mobx-react"
import { Tag, Typography } from "antd"

import { balancesStore } from "@src/app/balanceStore"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { PAYMENTS_PRICING_TYPES_OPTIONS } from "@src/pages/transactionsPayments/constants"
import {
  Payment,
  PaymentAmlLevelEnum,
  PaymentPricingTypeEnum,
  RefundResponse,
  RefundResponseFeePayerEnum,
  RefundResponseStatusEnum,
  TopupPaymentResponseStatusEnum,
} from "@src/shared/api/generated"
import { TableExpandable } from "@src/shared/componemts/TableExpandable"
import { WithCopy } from "@src/shared/componemts/WithCopy"
import { dateTimeFormat } from "@src/shared/date"
import { getExplorerUrl } from "@src/shared/getExplorerUrl"

export const RefundsTableExpandable = observer(
  ({ isLoading, payment }: { isLoading: boolean; payment: RefundResponse }) => {
    const {
      address_to,
      amount,
      charge_id,
      created_at,
      fee_payer,
      id,
      network,
      payment_id,
      status,
      symbol,
      tx_id,
    } = payment as Required<RefundResponse>

    const { currencies } = balancesStore

    const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
      network: network!,
      symbol: symbol!,
    })

    const operationWithUrl = getExplorerUrl([payment], currencies)[0]

    const cMapStatus = {
      [RefundResponseStatusEnum.Completed]: "green",
      [RefundResponseStatusEnum.Failed]: "error",
      [RefundResponseStatusEnum.Pending]: "geekblue",
    }

    const cMapFeePayer = {
      [RefundResponseFeePayerEnum.Customer]: "geekblue",
      [RefundResponseFeePayerEnum.Merchant]: "green",
    }

    return (
      <TableExpandable
        isLoading={isLoading}
        list={[
          ["ID", <WithCopy content={id!} />],
          ["Charge ID", <WithCopy content={charge_id!} />],
          ["Payment ID", <WithCopy content={payment_id!} />],
          ["Address", <WithCopy content={address_to!} />],
          [
            "Tx ID",
            <WithCopy
              content={tx_id!}
              view={
                <Typography.Link
                  href={operationWithUrl.tx_explorer_url + tx_id}
                  target="_blank"
                >
                  {tx_id}
                </Typography.Link>
              }
            />,
          ],
          [
            "Amount",
            <Typography style={{ fontWeight: 600 }}>{amount}</Typography>,
          ],
          ["Network", `${network}`],
          ["Symbol", `${currency?.symbol_alias ?? symbol}`],
          ["Status", <Tag color={cMapStatus[status]}>{status}</Tag>],
          ["Fee payer", <Typography.Text>{fee_payer}</Typography.Text>],
          ["Created at", dateTimeFormat(created_at as string)],
        ]}
      />
    )
  },
)
